import { getWishlistById as publicGetWishlistById } from './platform-v1-wishlist-wishlist.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getWishlistById: MaybeContext<
  BuildRESTFunction<typeof publicGetWishlistById> & typeof publicGetWishlistById
> = /*#__PURE__*/ createRESTModule(publicGetWishlistById);

export { WebhookIdentityType } from './platform-v1-wishlist-wishlist.universal.js';
export {
  WishlistData,
  WishlistItem,
  ItemsAddedToWishlist,
  ItemsRemovedFromWishlist,
  GetWishlistRequest,
  WishlistItemKind,
  GetWishlistResponse,
  AddToWishlistRequest,
  AddToWishlistResponse,
  RemoveFromWishlistRequest,
  RemoveFromWishlistResponse,
  GetWishlistByIdRequest,
  GetWishlistByIdResponse,
  GetWishlistsRequest,
  GetWishlistsResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetWishlistByIdOptions,
} from './platform-v1-wishlist-wishlist.universal.js';
export { WebhookIdentityTypeWithLiterals } from './platform-v1-wishlist-wishlist.universal.js';
